export default {
  /**
   * Set individual Employee leave list items.
   *
   * @param state
   * @param items
   */
  setIndividualEmployeeLeaveList(state, items) {
    console.log("Items : ", items);

    state.items = items;
  },

  /**
   * Set individual Employee filters.
   *
   * @param state
   * @param filters
   */
  setIndividualEmployeeLeaveListFilters(state, filters) {
    console.log("Filters", filters);

    state.filter = filters;
  },

  /**
   * Set individual Employee leave list pagination.
   *
   * @param state
   * @param pagination
   */
  setIndividualEmployeeLeaveListPagination(state, pagination) {
    console.log("Items : ", pagination);

    state.pagination = pagination;
  },

  /**
   * Set individual Employee leave list page.
   *
   * @param state
   * @param page
   */
  setIndividualEmployeeLeaveListPage(state, page) {
    console.log("Page : ", page);

    state.pagination.current_page = page;
  },
};
